var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-screen intro-screen"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('Button',{attrs:{"action":_vm.loadGameBoard}},[_vm._v(_vm._s(_vm.currentStageSettings.intro.button_text))])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4107380c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/StageIntro.vue
// module id = null
// module chunks = 